var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    { staticClass: "no-underline", attrs: { href: _vm.href, tabindex: "-1" } },
    [
      _c("DefaultWidget", {
        attrs: {
          name: "返回原版直播间",
          icon: "mdi-arrow-left-circle-outline",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }